import React from 'react';
import { Col, Form } from 'antd';

import { useApplicationContext } from '@/context/v1/Application/context';
import { SectorSelect } from '@/components/ui/Inputs/SectorSelect';
import { useSectors } from '@/hooks/v1';
import FormItem from '@/components/ui/FormItem';

const { useFormInstance, useWatch } = Form;

interface SectorsProps {
	disabled?: boolean;
}

export function Sectors({ disabled = false }: Readonly<SectorsProps>): JSX.Element {
	const form = useFormInstance();
	const { company, organization } = useApplicationContext();

	const companyId = useWatch('company_id', form);
	const sectorId = useWatch('sector_id', form);

	const {
		data: sectors,
		isLoading,
		isFetching,
		isError
	} = useSectors({
		organizationId: organization?.id,
		companyId: company?.id
	});

	function handleSectorSelect(id: string) {
		form.setFieldValue(['sector_id'], id);
		form.setFieldValue(['line_id'], undefined);
		form.setFieldValue(['workstation_id'], undefined);
	}

	function handleClearSector() {
		form.setFieldValue(['sector_id'], undefined);
		form.setFieldValue(['line_id'], undefined);
		form.setFieldValue(['workstation_id'], undefined);
	}

	return (
		<Col xs={24} sm={12}>
			<FormItem
				name={['sector_id']}
				label="Sector"
				labelCol={{ span: 24 }}
				requiredMessage="Select the sector"
				required
			>
				<SectorSelect
					size="large"
					sectors={sectors}
					sectorId={sectorId}
					loading={isFetching}
					fieldName="sector_id"
					handleClearSector={handleClearSector}
					handleSelectSector={handleSectorSelect}
					disabled={disabled || isLoading || isFetching || isError || !companyId}
				/>
			</FormItem>
		</Col>
	);
}
